export const ROUTES = {
  candidate: {
    summary: "/",
    admission: (idAdmission: string, idQuizzes: string) =>
      `/admission/${idAdmission}/quizzes/${idQuizzes}`,
    delivery: "/delivery",
    notsupport: "/notsupport",
  },
  logout: "/logout",
};
